import React, { FunctionComponent } from 'react';
import { Column, Row } from '@iag-packages/chroma-react/lib/layouts';

const GridWrapper: FunctionComponent<{
  md: number;
  offset: number;
  xs: number;
}> = ({ children, md, offset, xs }) => (
  <Row>
    <Column xs={xs} md={md} mdOffset={offset}>
      {children}
    </Column>
  </Row>
);

export default GridWrapper;
